import { endpoints } from "@/configs/Settings";
import { GetValueSet } from "@/services/terminology/GetValueSet";
import { auxiliarData } from "../AuxiliarData";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";
import { HTTPResponseStatus } from "@/utils/enum";

export async function PostPhysicalFindinds(objData: any, encounter: any) {
  try {
    const verifyValueset = await GetValueSet({
      valueset: "achados-fisicos",
      customUrl: "http://fluxmed.cloud/fhir/ValueSet/achados-fisicos",
      filter: objData?.text,
    });

    const auxLoinc = verifyValueset?.data?.expansion?.contains?.find(
      (el: any) =>
        el?.display
          ?.toLowerCase()
          ?.replace(/\./g, " ")
          ?.includes(objData?.text?.toLowerCase()?.replace(/\./g, " "))
    );
    objData.code = auxLoinc?.code || "";
    objData.display =
      auxLoinc?.display
        ?.split("Achados Físicos -")
        ?.map((part: any) => part.trim())?.[0] || objData.text;

    const url = `${endpoints.EHRPOSTER}/Observation`;
    const data = auxiliarData.PhysicalFindingsObservation(objData, encounter);
    const headers = {
      Accept: "application/fhir+json",
      Authorization: await useAuth.getUserToken(),
      "Content-Type": "application/fhir+json",
    };

    const response = await useAxios
      .post(url, data, { headers, timeout: 20000 })
      .then((response) => {
        if (
          response.status !== HTTPResponseStatus.Created &&
          response.status !== HTTPResponseStatus.Success
        ) {
          throw new Error(`PostPhysicalFindinds: ${response.status}`);
        }
        console.log("response", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("PostPhysicalFindinds ", error);
        throw new Error();
      });

    return response;
    // Só prossegue com o POST se encontrar uma correspondência exata
    if (verifyValueset?.data?.expansion?.contains?.length) {
    }

    // Se não encontrar correspondência exata, retorna sem fazer o POST
    return null;
  } catch (error) {
    console.error("PostPhysicalFindinds error:", error);
    throw error;
  }
}
